var Product_Gallery = {
	
	init:function(){
				
		var _carousel = $(".product-gallery");
		
		_carousel.slick({
			arrows:true, 
			dots:false,
			infinite: true,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow:_carousel.parent().find(".arrow.prev"),
			nextArrow:_carousel.parent().find(".arrow.next"),
		});	
	}	
}


$(document).ready(function(){
	if($(".product-gallery").length){
		Product_Gallery.init();
	}
})